export default __webpack_public_path__ + "static/media/Picture8.72ca1416.jpg";